import React, { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link, useLocation } from "react-router-dom"
import { isMobileContext } from "../context/isMobileContext"
// import { useTranslation } from "next-i18next"
// import { useRouter } from "next/router"
// import Link from "next/link"

function Footer() {
	const { isMobile } = useContext(isMobileContext)
	const { t, i18n } = useTranslation()
	const location = useLocation()
	const asPath = location.asPath
	const changeLanguageHandler = (lang) => {
		window.scrollTo({ top: 0, behavior: "auto" })
		setTimeout(() => {
			i18n.changeLanguage(lang)
			// localStorage.setItem("i18nextLng", lang);
		}, 200)
	}

	useEffect(() => {}, [i18n.language])

	return (
		<div className="footer">
			{!isMobile && (
				<div className="footerUpper">
					<div className="logo d-flex flex-column">
						<a href="https://www.ajman.ae/" target={"_blank"} rel="noreferrer">
							<img
								src={process.env.PUBLIC_URL + "/imgs/footer-logo.svg"}
								alt=""
							/>
						</a>
					</div>
					<div className="about">
						<span className="title">{t("footer.about")}</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/strategy`} scroll={false}>
								{t("footer.strategy")}
							</Link>
						</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/our-awards-and-certifications`} scroll={false}>
								{t("footer.appendices")}
							</Link>
						</span>
					</div>
					<div className="achievements">
						<span className="title">{t("footer.achievments")}</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/achievements/services`} scroll={false}>
								{t("footer.services")}
							</Link>
						</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/achievements/people`} scroll={false}>
								{t("footer.people")}
							</Link>
						</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/achievements/community`} scroll={false}>
								{t("footer.community")}
							</Link>
						</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/achievements/environment`} scroll={false}>
								{t("footer.environment")}
							</Link>
						</span>
					</div>
					<div className="support">
						{!isMobile && <span className="title">{t("footer.other")}</span>}
						{/* <span className='title' style={{marginBottom: '2rem', minHeight: '2rem'}}></span> */}
						<span>
							<a
								href={
									i18n.language === "ar"
										? process.env.PUBLIC_URL +
										  "/Ajman-Municipality-Sustainability-Report-2022A.pdf"
										: process.env.PUBLIC_URL +
										  "/Ajman-Municipality-Sustainability-Report-2022.pdf"
								}
								target="_blank"
								rel="noopener noreferrer"
								download={
									i18n.language === "ar"
										? process.env.PUBLIC_URL +
										  "/Ajman-Municipality-Sustainability-Report-2022A.pdf"
										: process.env.PUBLIC_URL +
										  "/Ajman-Municipality-Sustainability-Report-2022.pdf"
								}
								className="footer-download-link"
							>
								{t("footer.download")}
							</a>
						</span>
						{i18n.language === "en" && (
							<span
								onClick={() => {
									changeLanguageHandler("ar")
								}}
							>
								<Link to={asPath} locale={"ar"}>
									<span className={`lang gess-light`}>العربية</span>
								</Link>
							</span>
						)}
						{i18n.language === "ar" && (
							<span
								onClick={() => {
									changeLanguageHandler("en")
								}}
							>
								<Link to={asPath} locale={"en"}>
									<span className={`lang`}>English</span>
								</Link>
							</span>
						)}
					</div>
					{!isMobile && (
						<div className="contact">
							<span className="title">{t("footer.Contacts_us")}</span>
							<div className="mail contactItem">
								<div>
									<svg
										width="24"
										height="24"
										xmlns="http://www.w3.org/2000/svg"
										fillRule="evenodd"
										clipRule="evenodd"
									>
										<path d="M24 21h-24v-18h24v18zm-23-16.477v15.477h22v-15.477l-10.999 10-11.001-10zm21.089-.523h-20.176l10.088 9.171 10.088-9.171z" />
									</svg>
								</div>
								<a href="mailto:80070@ajman.ae">{t("footer.mail")}</a>
							</div>
							<div className="phone contactItem">
								<div>
									<svg
										width="24"
										height="24"
										xmlns="http://www.w3.org/2000/svg"
										fillRule="evenodd"
										clipRule="evenodd"
									>
										<path d="M8.26 1.289l-1.564.772c-5.793 3.02 2.798 20.944 9.31 20.944.46 0 .904-.094 1.317-.284l1.542-.755-2.898-5.594-1.54.754c-.181.087-.384.134-.597.134-2.561 0-6.841-8.204-4.241-9.596l1.546-.763-2.875-5.612zm7.746 22.711c-5.68 0-12.221-11.114-12.221-17.832 0-2.419.833-4.146 2.457-4.992l2.382-1.176 3.857 7.347-2.437 1.201c-1.439.772 2.409 8.424 3.956 7.68l2.399-1.179 3.816 7.36s-2.36 1.162-2.476 1.215c-.547.251-1.129.376-1.733.376" />
									</svg>
								</div>
								<a href="tel:971 674 41616">{t("footer.phone")}</a>
							</div>
							<div className="address contactItem">
								<a href="https://goo.gl/maps/ArjGWjRvC8Wbu6ui6" target="_blank">
									<div>
										<svg
											width="24"
											height="24"
											xmlns="http://www.w3.org/2000/svg"
											fillRule="evenodd"
											clipRule="evenodd"
										>
											<path d="M12 10c-1.104 0-2-.896-2-2s.896-2 2-2 2 .896 2 2-.896 2-2 2m0-5c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m-7 2.602c0-3.517 3.271-6.602 7-6.602s7 3.085 7 6.602c0 3.455-2.563 7.543-7 14.527-4.489-7.073-7-11.072-7-14.527m7-7.602c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602" />
										</svg>
									</div>
									<span>
										{t("footer.address")}
										<br />
										{t("footer.address2")}
										<br />
										{t("footer.address3")}
									</span>
								</a>
							</div>
						</div>
					)}
				</div>
			)}
			{isMobile && (
				<div className="footerUpper">
					<div className="logo d-flex flex-column">
						<img
							src={process.env.PUBLIC_URL + "/imgs/footer-logo.svg"}
							alt=""
						/>
					</div>
					<div className="achievements mobile-achievements">
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/strategy`} scroll={false}>
								{t("footer.strategy_mobile")}
							</Link>
						</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/achievements/services`} scroll={false}>
								{t("footer.services_mobile")}
							</Link>
						</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/achievements/people`} scroll={false}>
								{t("footer.people_mobile")}
							</Link>
						</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/achievements/community`} scroll={false}>
								{t("footer.community_mobile")}
							</Link>
						</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/achievements/environment`} scroll={false}>
								{t("footer.environment_mobile")}
							</Link>
						</span>
						<span onClick={() => window.scrollTo({ top: 0 })}>
							<Link to={`/our-awards-and-certifications`} scroll={false}>
								{t("footer.appendices")}
							</Link>
						</span>
					</div>
					<div className="support">
						{!isMobile && <span className="title">{t("footer.other")}</span>}
						<span>
							<a
								href={
									i18n.language === "ar"
										? process.env.PUBLIC_URL +
										  "/Ajman-Municipality-Sustainability-Report-2022A.pdf"
										: process.env.PUBLIC_URL +
										  "/Ajman-Municipality-Sustainability-Report-2022.pdf"
								}
								
								target="_blank"
								rel="noopener noreferrer"
								download={
									i18n.language === "ar"
										? process.env.PUBLIC_URL +
										  "/Ajman-Municipality-Sustainability-Report-2022A.pdf"
										: process.env.PUBLIC_URL +
										  "/Ajman-Municipality-Sustainability-Report-2022.pdf"
								}
								className="footer-download-link"
							>
								{t("footer.download")}
							</a>
						</span>
						{i18n.language === "en" && (
							<span
								onClick={() => {
									changeLanguageHandler("ar")
								}}
							>
								<Link to={asPath} locale={"ar"}>
									<span className={`lang gess-light`}>العربية</span>
								</Link>
							</span>
						)}
						{i18n.language === "ar" && (
							<span
								onClick={() => {
									changeLanguageHandler("en")
								}}
							>
								<Link to={asPath} locale={"en"}>
									<span className={`lang`}>English</span>
								</Link>
							</span>
						)}
					</div>
					{!isMobile && (
						<div className="contact">
							<span className="title">{t("footer.Contacts_us")}</span>
							<div className="mail contactItem">
								<div>
									<svg
										width="24"
										height="24"
										xmlns="http://www.w3.org/2000/svg"
										fillRule="evenodd"
										clipRule="evenodd"
									>
										<path d="M24 21h-24v-18h24v18zm-23-16.477v15.477h22v-15.477l-10.999 10-11.001-10zm21.089-.523h-20.176l10.088 9.171 10.088-9.171z" />
									</svg>
								</div>
								<a href="mailto:80070@ajman.ae">{t("footer.mail")}</a>
							</div>
							<div className="phone contactItem">
								<div>
									<svg
										width="24"
										height="24"
										xmlns="http://www.w3.org/2000/svg"
										fillRule="evenodd"
										clipRule="evenodd"
									>
										<path d="M8.26 1.289l-1.564.772c-5.793 3.02 2.798 20.944 9.31 20.944.46 0 .904-.094 1.317-.284l1.542-.755-2.898-5.594-1.54.754c-.181.087-.384.134-.597.134-2.561 0-6.841-8.204-4.241-9.596l1.546-.763-2.875-5.612zm7.746 22.711c-5.68 0-12.221-11.114-12.221-17.832 0-2.419.833-4.146 2.457-4.992l2.382-1.176 3.857 7.347-2.437 1.201c-1.439.772 2.409 8.424 3.956 7.68l2.399-1.179 3.816 7.36s-2.36 1.162-2.476 1.215c-.547.251-1.129.376-1.733.376" />
									</svg>
								</div>
								<a href="tel:971 674 41616">{t("footer.phone")}</a>
							</div>
							<div className="address contactItem">
								<a href="https://goo.gl/maps/ArjGWjRvC8Wbu6ui6" target="_blank">
									<div>
										<svg
											width="24"
											height="24"
											xmlns="http://www.w3.org/2000/svg"
											fillRule="evenodd"
											clipRule="evenodd"
										>
											<path d="M12 10c-1.104 0-2-.896-2-2s.896-2 2-2 2 .896 2 2-.896 2-2 2m0-5c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m-7 2.602c0-3.517 3.271-6.602 7-6.602s7 3.085 7 6.602c0 3.455-2.563 7.543-7 14.527-4.489-7.073-7-11.072-7-14.527m7-7.602c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602" />
										</svg>
									</div>
									<span>
										{t("footer.address")}
										<br />
										{t("footer.address2")}
										<br />
										{t("footer.address3")}
									</span>
								</a>
							</div>
						</div>
					)}
				</div>
			)}
			<div className="copyrights">
				<span>{t("footer.copyrights")}</span>
				<div className="socialIcons">
					<a
						href="https://www.facebook.com/ajmanmunicipality/"
						target="_blank"
						rel="noreferrer"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
						</svg>
					</a>
					<a
						href="https://www.instagram.com/ajmanmunicipality/"
						target="_blank"
						rel="noreferrer"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
							<path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
						</svg>
					</a>
					<a
						href="https://www.youtube.com/user/AJmunicipality"
						target="_blank"
						rel="noreferrer"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
							<path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
						</svg>
					</a>

					<a
						href="https://twitter.com/ajmanmun"
						target="_blank"
						rel="noreferrer"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
							<path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
						</svg>
					</a>
				</div>
			</div>
			<div className="background">
				<img
					src={
						process.env.PUBLIC_URL +
						(isMobile ? "/imgs/footer-mobile.png" : "/imgs/footer.png")
					}
					alt="footer_background"
				/>
			</div>
		</div>
	)
}

export default Footer
